import { useState } from 'react';

interface HeaderProps {
  isScrolled: boolean;
}

export default function Header({ isScrolled }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-md'}`}>
      <div className="flex items-center justify-between px-4 py-3 max-w-6xl mx-auto">
        <div className="flex items-center space-x-3 flex-1">
          <div className="h-8">
            <img 
              src="https://static.readdy.ai/image/54a81377d2a88f03463864bd512c4100/56a40044976b9a3abcc586166eaf9251.jpeg" 
              alt="SunAce" 
              className="h-full w-auto object-contain"
            />
          </div>
          <div className="text-sm font-bold text-primary">
            <div className="text-xs text-green-600">電気工事の</div>
            <div className="text-sm text-green-600">株式会社SunAce</div>
          </div>
        </div>
        <button 
          onClick={toggleMobileMenu}
          className="w-8 h-8 flex items-center justify-center cursor-pointer"
        >
          <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl text-green-700`}></i>
        </button>
      </div>
      {isMobileMenuOpen && (
        <nav className="bg-white border-t">
          <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-3 text-green-700 hover:bg-gray-50 cursor-pointer">事業内容</button>
          <button onClick={() => scrollToSection('philosophy')} className="block w-full text-left px-4 py-3 text-green-700 hover:bg-gray-50 cursor-pointer">企業理念・代表挨拶</button>
          <button onClick={() => scrollToSection('projects')} className="block w-full text-left px-4 py-3 text-green-700 hover:bg-gray-50 cursor-pointer">施工実績</button>
          <button onClick={() => scrollToSection('careers')} className="block w-full text-left px-4 py-3 text-green-700 hover:bg-gray-50 cursor-pointer">採用情報</button>
          <button onClick={() => scrollToSection('news')} className="block w-full text-left px-4 py-3 text-green-700 hover:bg-gray-50 cursor-pointer">ニュース</button>
          <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-3 text-green-700 hover:bg-gray-50 cursor-pointer">お問い合わせ</button>
          <button onClick={() => scrollToSection('overview')} className="block w-full text-left px-4 py-3 text-green-700 hover:bg-gray-50 cursor-pointer">会社概要</button>
        </nav>
      )}
    </header>
  );
}
